import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const CameraDropDownHM = ({
  userFilters,
  setUserFilters,
  cameraOptions,
  cameraDropDownValue,
  setCameraDropDownValue,
  siteOptions,
  loadingCameras,
  navBarCollapsed,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  cameraOptions: any;
  cameraDropDownValue: any;
  setCameraDropDownValue: Dispatcher<string>;
  siteOptions: any;
  loadingCameras: boolean;
  navBarCollapsed: boolean;
}) => {
  const cameraIdsMap = new Map();
  const cameraNamesMap = new Map();
  cameraOptions.forEach((object: any) => {
    cameraIdsMap.set(object.camera_name, object.id);
  });
  cameraOptions.forEach((object: any) => {
    cameraNamesMap.set(object.id, object.camera_name);
  });

  const siteIdsMap = new Map();
  siteOptions.forEach((object: any) => {
    siteIdsMap.set(object.name, object.id);
  });

  return (
    <div>
      <Autocomplete
        disablePortal
        options={
          cameraOptions[0]
            ? cameraOptions.map((object: any, index: number) => ({
                id: object.id,
                name: object.camera_name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          userFilters.camera
            ? {
                id: Number(userFilters.camera),
                name: cameraNamesMap.get(Number(userFilters.camera)),
                index: cameraOptions.findIndex(
                  (obj: any) => obj.id === Number(userFilters.camera)
                ),
              }
            : null
        }
        loading={loadingCameras}
        onChange={(event, value: any) => {
          if (value !== null) {
            setCameraDropDownValue(value.name);
            setUserFilters((previousState: any) => {
              return { ...previousState, camera: value.id };
            });
          } else {
            setCameraDropDownValue("");
            setUserFilters((previousState: any) => {
              return { ...previousState, camera: "" };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Camera"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCameras ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={!navBarCollapsed ? { width: 175 } : { width: 200 }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
